export const getUserRole = () => {
  try {
    const storedData = localStorage.getItem('__TG-EMP')
    if (storedData) {
      const parsedData = JSON.parse(storedData)
      return parsedData.role
    }
  } catch (error) {
    console.error('Error parsing user role:', error)
  }
  return null
}
